import anime from 'animejs'
import enquire from 'enquire.js'

import Component from '../core/Component'
import { queries } from '../core/config'

const defaults = {
    easing: "linear",
    duration: 30000,
    loop: true,
    direction: "normal",
}

export default class Planes extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            paths: [],
            planes: []
        }

        this.enquireHandler = {
            match: this.match.bind(this),
            unmatch: this.unmatch.bind(this),
        }
    }

    prepare() {
        enquire.register(queries.mediumUp, this.enquireHandler);
    }

    destroy() {
        enquire.unregister(queries.mediumUp, this.enquireHandler);
    }

    match() {
        this.render()
    }

    unmatch() {
        anime.remove(this.ref.planes);

        this.ref.planes.forEach(plane => {
            plane.removeAttribute('style')
        })
    }

    render = () => {
        this.ref.planes.forEach((plane, index) => {
            const path = this.ref.paths[index]

            if (path && plane) {
                setTimeout(() => {
                    anime({
                        targets: plane,
                        translateX: anime.path(path)('x'),
                        translateY: anime.path(path)('y'),
                        rotate: anime.path(path)('angle'),
                        ...this.options,
                        begin: () => {
                            plane.style.opacity = 1
                        }
                    });
                }, index * 5000)
            }
        })
    }
}
